// extracted by mini-css-extract-plugin
module.exports = {"nav__locale":"NavLocaleLanguage_nav__locale__Rbjlw","nav__locale-buttons":"NavLocaleLanguage_nav__locale-buttons__hvg76"};